module.exports = __webpack_public_path__ + "img/1280.3b80dab8.svg";